import { Component, Fragment } from 'react'
import './ImageComponent.scss'

type ImageComponentProps = {
  url: string
  description: string
}
class ImageComponent extends Component<Partial<ImageComponentProps>> {
  state = {
    isOpen: false
  }

  closeModal = () => this.setState({ isOpen: false })
  openModal = () => this.setState({ isOpen: true })

  render() {
    const { isOpen } = this.state
    const { url, description } = this.props
    return (
      <Fragment>
        <div
          className={`image-container--zoom ${isOpen ? 'open' : ''}`}
          onClick={this.closeModal}
        >
          <button
            onClick={this.closeModal}
            className="image-container--zoom-close"
            aria-label="Close image modal"
          />
          <img
            className="image-container--zoom-item"
            onClick={(evt) => evt.stopPropagation()}
            src={url}
            alt={description}
          />
        </div>
        <img
          className="media-item message-text media-image"
          onClick={this.openModal}
          src={url}
          alt={description}
        />
      </Fragment>
    )
  }
}

export default ImageComponent
